import { create } from "zustand";

const useFAQStore = create((set, get) => ({
  faqs: [],
  loading: false,
  error: null,
  getFAQs: async () => {
    if (get().loading) return; // Prevent multiple simultaneous fetches
    set({ loading: true, error: null });
    try {
      const faqResponse = [
        {
          Title: "PRODUCTS & PERSONALISATION",
          FAQs: [
            {
              Question: "Ready-made or custom hampers?",
              Answer:
                "We offer both ready-made hampers at pop-ups and custom hampers you can personalise. Browse [Occasions](/Occasions) for more ideas.",
            },
            {
              Question: "Can I personalise every product?",
              Answer:
                "Most products can be personalised. Some items, like Bath & Body sets or Dog Rope Toys, cannot.",
            },
            {
              Question: "How do I add personalisation details?",
              Answer:
                "Tell us your desired text or design and preferred colour when ordering.",
            },
            {
              Question: "What if I make a spelling mistake?",
              Answer:
                "Contact us immediately. If the order hasn’t been processed, we can fix it. Once personalised, changes require a re-order.",
            },
            {
              Question: "Is personalisation included in the price?",
              Answer:
                "Yes, standard personalisation is included. Special designs may incur extra charges, discussed before payment.",
            },
            {
              Question: "Can I add alcohol to a hamper?",
              Answer:
                "Yes, request your recipient’s favourite liquor to be added to their hamper. See [Terms & Policies](/Customer-Services/Terms/#Liquor-licensing) for age restrictions.",
            },
          ],
        },
        {
          Title: "GIFT WRAPPING",
          FAQs: [
            {
              Question: "Is gift wrap included?",
              Answer:
                "Every hamper is beautifully wrapped with signature tissue and ribbon. Individual products can be wrapped at an extra charge.",
            },
            {
              Question: "What should I write on the gift tag?",
              Answer:
                "Include the recipient’s name, occasion, and who the gift is from. [See Gift Wrap](/Customer-Services/Giftwrap) for tips.",
            },
          ],
        },
        {
          Title: "ORDERS & DELIVERY",
          FAQs: [
            {
              Question: "How do I place an order?",
              Answer:
                "Browse our website and [contact us via email or WhatsApp](/Customer-Services/Contact). You can also order in person at a [pop-up event](/Customer-Services/Popups).",
            },
            {
              Question: "Can I order corporate gifts or bulk hampers?",
              Answer:
                "Yes, we can create personalised hampers for corporate gifts or bulk orders. [Contact us](/Customer-Services/Contact) to discuss your requirements.",
            },
            {
              Question: "Do you deliver outside Jersey?",
              Answer:
                "Yes, we can deliver to the UK and internationally. Delivery charges and times vary by location. [Contact us](/Customer-Services/Contact) to discuss your requirements before placing an order.",
            },
            {
                Question: "Can I choose a delivery date?",
                Answer:"Yes, many customers order early for events like Christmas. Standard turnaround is two weeks; contact us for urgent orders."
            },
            {
                Question: "Can I send a gift directly to the recipient?",
                Answer: "Yes, provide the recipient’s address during checkout, and we will deliver it directly to them."
            }
          ],
        },
        {
          Title: "PAYMENTS & REFUNDS",
          FAQs: [
            {
              Question: "How can I pay?",
              Answer: "We accept BACS, all major cards, and cash at pop-ups.",
            },
            {
              Question: "Can I get a refund on personalised items?",
              Answer:
                "Personalised items cannot be refunded unless faulty. See [Terms & Policies](/Customer-Services/Terms).",
            },
          ],
        },
        {
          Title: "CUSTOMER SERVICE",
          FAQs: [
            {
              Question: "How can I contact you?",
              Answer:
                "Email, WhatsApp, or social media. See [Contact Us](/Customer-Services/Contact) for more details.",
            },
            {
              Question: "Where can I meet you in person?",
              Answer:
                "We attend pop-up events. See [Pop-Up Dates](/Customer-Services/Popups) for our schedule.",
            },
          ],
        },
      ];

      set({ faqs: faqResponse, loading: false });
    } catch (error) {
      set({ error, loading: false });
    }
  },
}));

export default useFAQStore;
